export class Ressource {
    public static DATA: string = "";
    public static BASE: string = "";

    public static init(): void {
        Ressource.DATA = document.body.getAttribute("data-data");
        Ressource.BASE = document.body.getAttribute("data-base");
    }
}